module.exports = __webpack_public_path__ + "static/media/Tunbay.0475bb2a.png";